<template>
  <VpFormLayout>
    <template v-slot:content-header>
      <Breadcrumb style="background-color: transparent" :items="items" />
    </template>
    <template v-slot:content-body>
      <div class="usersNotOnSite-form">
        <!-- Sites dropdown -->
        <VpTreeselect
          zIndex="100"
          :showPlaceholderIcon="true"
          width="416"
          :showOptionsBorder="true"
          :showNoResults="true"
          v-model="sitesValue"
          :isLoading="sitesLoading"
          :options="sites"
          :allowEmpty="true"
          :show-labels="true"
          :isMultiple="true"
          :label="$t('common.site')"
          :disabled="!sites.length"
          noResultMessage="No results found"
          @input="changeSitesValue"
        />
        <p class="noUserTypesInFlow" v-if="isNoUserTypes && !userTypes.length">
          Note: No user types are permitted to enter the selected sites, please
          check again.
        </p>

        <!-- UserType treelist -->
        <VpTreeselect
          zIndex="100"
          :showPlaceholderIcon="true"
          width="416"
          :showOptionsBorder="true"
          :showNoResults="true"
          v-model="userTypesValue"
          :isLoading="userTypesLoading"
          :options="userTypes"
          :allowEmpty="true"
          :show-labels="true"
          :isMultiple="true"
          :label="$t('common.userType')"
          :disabled="!sitesValue.length || isDisabledUserTypes"
          noResultMessage="No results found"
        />
      </div>
    </template>

    <template v-slot:content-footer>
      <vpButton
        :class="{
          'disabled-cursor': !sitesValue.length || !userTypesValue.length,
        }"
        type="submit"
        :text="$t('common.generate')"
        @click="generateUsersReport"
        :disabled="!sitesValue.length || !userTypesValue.length"
      />
    </template>
  </VpFormLayout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";

export default {
  //   name: "usersNotOnSiteForm",
  //   title: "Users not on site",
  data() {
    return {
      sitesValue: [],
      userTypesValue: [],
      sites: [],
      userTypes: [],
      isNoUserTypes: false,
      sitesLoading: true,
      userTypesLoading: false,
      isDisabledUserTypes: false,
      items: [
        { text: this.$t('sideNavbarMenu.reporting.text')},
        {
          text: this.$t('sideNavbarMenu.reporting.list.UsersNotOnSite'),
          active: true,
        },
      ],
    };
  },
  components: {
    Breadcrumb,
  },
  watch: {
    getUserTypesBySitesIds(data) {
      let items = [];
      if (data && data.length) {
        items = data.map((item) => {
          if (item.children && item.children.length) {
            item.children.map((child) => {
              Object.assign(child, { label: child.name });
            });
          } else {
            delete item.children;
          }
          return Object.assign(item, { label: item.name });
        });
        this.isDisabledUserTypes = false;
      } else this.isNoUserTypes = true;

      this.userTypes = items;
    },
  },
  computed: {
    ...mapGetters("sites", ["getSites"]),
    ...mapGetters("userType", ["getUserTypesBySitesIds"]),
  },
  methods: {
    ...mapActions("sites", ["fetchSites"]),
    ...mapActions("userType", ["fetchUserTypesBySitesIds"]),
    changeSitesValue() {
      const { fetchUserTypesBySitesIds, sitesValue } = this;
      this.userTypes = [];
      this.userTypesValue = [];
      this.userTypesLoading = false;
      this.isNoUserTypes = false;
      if (sitesValue.length) {
        this.isDisabledUserTypes = true;
        this.userTypesLoading = true;
        setTimeout(() => {
          fetchUserTypesBySitesIds({
            params: {
              usersNotOnSite: true,
              site_ids: sitesValue,
            },
          }).then(() => {
            this.userTypesLoading = false;
          });
        }, 1000);
      }
    },
    generateUsersReport() {
      this.$emit("usersNotOnSiteSubmitForm", {
        sites: this.sitesValue,
        userTypes: this.userTypesValue,
      });
    },
  },
  beforeMount() {
    this.fetchSites().then((data) => {
      const sitesList =
        data?.data?.filter((site) => site.areas_count > 0) || [];
      this.sitesLoading = false;
      this.sites = sitesList;
    });
  },
};
</script>

<style lang="scss">
.usersNotOnSite-form {
  min-height: 445px !important;
  background-color: white;
  padding-top: 47px;
  padding-inline-start: 39px;
  border-radius: 8px;
}

.disabled-cursor {
  cursor: not-allowed;
}
.disabledUserTypes {
  opacity: 0.3;
  cursor: not-allowed;
}
.noUserTypesInFlow {
  width: 415px;
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.25px;
  color: #939393;
  opacity: 0.8;
  margin-bottom: 17px !important;
}

</style>
